import { render, staticRenderFns } from "./OrderCarItem.vue?vue&type=template&id=846e1cc4&scoped=true&"
import script from "./OrderCarItem.vue?vue&type=script&lang=js&"
export * from "./OrderCarItem.vue?vue&type=script&lang=js&"
import style0 from "./OrderCarItem.vue?vue&type=style&index=0&id=846e1cc4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "846e1cc4",
  null
  
)

export default component.exports